export default __webpack_public_path__ + "static/media/i058jk.7e6a7bce.webp";